module.exports = __webpack_public_path__ + "img/map-empty.6c7abe7c.svg";